import { Box, Stack, Typography, useTheme } from "@mui/material";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useCallback } from "react";
import CountUp from "../../../components/animation/countUp/countUp";
import { useTranslation } from "react-i18next";
import './hero.css';

const HeroImage = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const geTotalYearsInIndustry = useCallback(() => {
        const today = new Date();
        return today.getFullYear() - 2022;
    }, []);

    return (
        <>
            <Box
                position='relative'
                width='100%'
            >
                <img
                    src="/images/hero.png" 
                    alt="Hero" 
                    style={{
                        width: '100%',
                        position: 'relative'
                    }}
                />

                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: '35%',
                        height: '45%',
                        border: `3px solid ${theme.palette.text.primary}`,
                        borderRadius: '16px'
                    }}
                >
                    <Stack
                        direction='column'
                        justifyContent='center'
                        alignItems='center'
                        height='100%'
                        px={5}
                    >
                        <Typography
                            fontWeight={700}
                            fontSize={{xs: 24, md: 32, lg: 50}}
                            textAlign='center'
                            color={theme.palette.text.primary}
                        >
                            {
                                geTotalYearsInIndustry() < 10
                                ?
                                <span>0</span>
                                :
                                <></>
                            }
                            
                            <CountUp
                                from={0}
                                to={geTotalYearsInIndustry()}
                                separator="+"
                                direction="up"
                                duration={1}
                                className="count-up-text"
                            />

                            <span>+</span>
                        </Typography>

                        <AutoAwesomeIcon 
                            sx={{
                                color: theme.palette.text.primary,
                                animation: 'bounce 2s infinite'
                            }}
                        />

                        <Typography
                            fontWeight={500}
                            fontSize={{xs: 12, md: 14, lg: 16}}
                            textAlign='center'
                            pt={2}
                            color={theme.palette.text.secondary}
                        >
                            {t(`hero.years`)}
                        </Typography>
                    </Stack>
                </Box>
            </Box>
        </>
    );
}

export default HeroImage;